import { Controller } from "react-hook-form";
import { SelectField } from "../../ui";
import { WorkStatusEnum } from "../../../utils/enum/enum";

interface SelectWorkStatusProps {
    name: string;
    methods: any;
    disabled?: boolean;
    required?: boolean;
    label?: string;
}

export function SelectWorkStatus({
    name,
    methods,
    disabled = false,
    required = false,
    label = "Status da Obra",
}: SelectWorkStatusProps) {
    return (
        <Controller
            name={name}
            control={methods.control}
            render={({ field, formState: { errors } }) => (
                <SelectField
                    label={label}
                    value={field.value || ""}
                    onChange={(e) => field.onChange(e.target.value)}
                    required={required}
                    disabled={disabled}
                    error={!!errors[name as keyof typeof errors]}
                >
                    <option value={WorkStatusEnum.ACTIVE}>Ativada</option>
                    <option value={WorkStatusEnum.PAUSED}>Pausada</option>
                    <option value={WorkStatusEnum.DISABLED}>Desativar</option>
                    <option value={WorkStatusEnum.CANCELED}>Cancelada</option>
                </SelectField>
            )}
        />
    );
}
